export default __webpack_public_path__ + "static/media/pit2.055598c5.png";